
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.694 6.917a.694.694 0 11-1.388 0 .694.694 0 011.388 0zM9.417 8.653a.417.417 0 10-.834 0v2.777a.417.417 0 10.834 0V8.654z","fill":"#E16F24"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.96 3.867c.959-1.477 3.12-1.477 4.08 0l4.498 6.935c1.049 1.617-.112 3.754-2.04 3.754H4.502c-1.927 0-3.088-2.137-2.039-3.754l4.499-6.935zm3.497.378a1.736 1.736 0 00-2.914 0L3.045 11.18c-.75 1.155.08 2.681 1.456 2.681H13.5c1.377 0 2.205-1.526 1.456-2.68l-4.498-6.936z","fill":"#E16F24"}})])
          )
        }
      }
    